import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import { fetchEndCustomerContactsPPC } from '../../../queries/fetch-end-customer-contacts-ppc';

interface UseFetchEndCustomerContactstPPCQueryVariables {
  entitlementId: string;
  transactionAccountId: string;
  skip?: boolean;
}

export const useFetchEndCustomerContactstPPCQuery = ({
  entitlementId,
  transactionAccountId,
  skip,
}: UseFetchEndCustomerContactstPPCQueryVariables) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);
  return usePersistedCacheQuery<
    generatedTypesNew.FetchEndCustomerContactsPpcQuery,
    generatedTypesNew.FetchEndCustomerContactsPpcQueryVariables
  >(fetchEndCustomerContactsPPC, {
    variables: {
      id: entitlementId,
      transactionAccountId: transactionAccountId,
      isRestricted: false,
    },
    client: ansClient,
    skip: skip,
  });
};
